import React, { Component } from 'react';
import { connect } from 'react-redux';
import Server from './Server.js'
import { SelectButton } from 'primereact/selectbutton';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Link } from 'react-router-dom'
import Header from './Header.js'

class Shop extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef()   // Create a ref object
    this.Server = new Server();
    this.state = {
      list:[],
      shopGroups: [],
      ShowLoading: false,
      shopGroup: window.location.href.split("_id=")[1],
      absoluteUrl: this.Server.getAbsoluteUrl(),

    }


  }
  componentDidMount() {
    this.getshopInfo(this.state.shopGroup);
  }
  render() {
    
    return (

      <div style={{ height: '100%' }}>
          <div>
          <Header ComponentName="صفحه فروشگاه" ComponentLName="app-icon-4" />
        </div>
        {!this.state.ShowLoading ?
        <div style={{textAlign: 'center',marginTop:200}}>
         <p>در حال پیاده سازی ...</p>
        </div>
        :
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',height:'100%' }}>
          <ProgressSpinner style={{width: '50px', height: '50px'}} strokeWidth="2" fill="var(--surface-ground)" animationDuration=".5s" />
        </div>
      }
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData:state.appData,
    creditPrice:state.creditPrice,
    systemId:state.systemId
  }
}
export default connect(mapStateToProps)(Shop)

